/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import styles from '../../styles/scheduler/YearPicker.module.css';

const PER_PAGE = 12;

interface YearPickerProps {
	selectedYear: number;
	currentYear: number;
	onSelectYear: (year: number) => void;
}

const YearPicker: React.FC<YearPickerProps> = ({
	selectedYear,
	currentYear,
	onSelectYear,
}) => {
	const [pageStart, setPageStart] = useState(() => selectedYear - 1);
	const years = Array.from({ length: PER_PAGE }, (_, i) => pageStart + i);
	const rows: number[][] = [];
	for (let i = 0; i < years.length; i += 4) rows.push(years.slice(i, i + 4));

	return (
		<div className={styles.picker}>
			<div className={styles.header}>
				<button
					className={styles.nav}
					onClick={() => setPageStart(p => p - PER_PAGE)}
				>
					‹
				</button>
				<p className={styles.title}>Select Year</p>
				<button
					className={styles.nav}
					onClick={() => setPageStart(p => p + PER_PAGE)}
				>
					›
				</button>
			</div>
			{rows.map((row, ri) => (
				<div key={ri} className={styles.row}>
					{row.map(y => (
						<button
							key={y}
							className={[
								styles.cell,
								y === selectedYear ? styles.selected : '',
								y === currentYear && y !== selectedYear
									? styles.current
									: '',
							].join(' ')}
							onClick={() => onSelectYear(y)}
						>
							{y}
						</button>
					))}
				</div>
			))}
		</div>
	);
};

export default YearPicker;
